import { render, staticRenderFns } from "./RepeatSendLogs.table.daily.vue?vue&type=template&id=af74f9e2&"
import script from "./RepeatSendLogs.table.daily.vue?vue&type=script&lang=js&"
export * from "./RepeatSendLogs.table.daily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports